import {
  APPLICATION_NAME,
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
  APP_LOGO,
} from '../../js/constants';
import EventBus from '../../js/event-bus';
import Sync from '../../services/Sync.js';

export default {
  namespaced: true,

  state: {
    appConfig: {
      name: APPLICATION_NAME,
      logoUrl: APP_LOGO,
      apiBaseUrl: null,
      primaryColor: DEFAULT_PRIMARY_COLOR,
      secondaryColor: DEFAULT_SECONDARY_COLOR,
    },
    loggedUser: null,
    wantToRemember: false,
    wantToRecoveryPass: false,
    changePassword: false,
    messageChangePassword: false,
    currentLocation: null,
    user: null,
    actualMenuSelected: undefined,
  },

  getters: {
    getWantToRemember: (state) => state.wantToRemember,
    getPermissions: (state) => state.user.permissions,
    userFarmsIds: (state) => state.user.farms_id,
    getActualMenuSelected: (state) => state.actualMenuSelected,
    currentUser(state) {
      return `${state.user.user.contact.name} ${state.user.user.contact.surname}`;
    },
    isAdmin: (state) => state.user.user.contact.admin,
    mapBoxAccessToken(state) {
      return state.user.user.contact.mapBoxAccessToken
        ? state.user.user.contact.mapBoxAccessToken : 'pk.eyJ1IjoiaGlzcGF0ZWMtZ2lzIiwiYSI6ImNsdHJmMTh1ajBncmUybm5qb2k0YWZjbnUifQ.qiPSRp3oveeVxVGihnoq1g';
    },
  },

  actions: {
    initialize(context) {
      if (context.state.loggedUser) {
        EventBus.$emit('newLoggedUser', context.state.loggedUser);
      }
      EventBus.$on('invalidTokenDetected', () => context.dispatch('logout'));
      EventBus.$on('newLoggedUser', (newLoggedUser) => context.commit('setLoggedUser', newLoggedUser));
      EventBus.$on('newLoggedUser', (newLoggedUser) => context.commit('setUser', JSON.parse(newLoggedUser)));
      EventBus.$on('newAccessToken', (newAccessToken) => context.commit('setUserAccessToken', newAccessToken));
    },

    async logout(context) {
      context.commit('setLoggedUser', null);
      context.commit('setWantToRemember', false);
      context.commit('setActualMenuSelected', undefined);
      Sync.clearDatabase();
      await context.dispatch('AccessControl/destroy', null, { root: true });
      await context.dispatch('SearchEngine/setLoadOffline', false);
      window.localStorage.clear();
      window.location.reload();
    },

    selectLocation(context, value) {
      context.commit('setCurrentLocation', value);
    },

    wantToRecoveryPass(context) {
      context.commit('wantToRecoveryPass');
    },

    changePassword(context) {
      context.commit('changePassword');
    },

    setMessageChangePassword(context) {
      context.commit('setMessageChangePassword');
    },
    setActualMenuSelected({ commit }, payload) {
      commit('setActualMenuSelected', payload);
    },
    setUserAccessToken({ commit }, newAccessToken) {
      commit('setUserAccessToken', newAccessToken);
    },
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setLoggedUser(state, user) {
      state.loggedUser = user;
    },

    setAppConfig(state, value) {
      state.appConfig = value;
    },

    setWantToRemember(state) {
      state.wantToRemember = !state.wantToRemember;
    },

    wantToRecoveryPass(state) {
      state.wantToRecoveryPass = !state.wantToRecoveryPass;
    },

    changePassword(state) {
      state.changePassword = !state.changePassword;
    },

    setMessageChangePassword(state) {
      state.messageChangePassword = !state.messageChangePassword;
    },
    setActualMenuSelected(state, payload) {
      state.actualMenuSelected = payload;
    },
    setUserAccessToken(state, newAccessToken) {
      state.user.access = newAccessToken;
    },
  },
};
